import { Popover } from "antd-v5";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import _, { isEmpty } from "lodash";
import React, { useCallback, useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";

// data and score used when using only popover
// getting data externally other get from AATI score colum record
export const useAATIScoreColumn = () => {
  const featureFlags = useFeatureFlag();
  const getAATIScoreWithPopover = useCallback(
    (aatiScore, data) => {
      const scoreValue = aatiScore;
      if (
        featureFlags.AATIV2_SCORE &&
        !isEmpty(data?.otherProperties?.AATI_SCORE_COMMENTARIES)
      ) {
        return (
          <Popover
            content={_.map(
              data?.otherProperties?.AATI_SCORE_COMMENTARIES,
              (commentary: string) => {
                return (
                  <ul>
                    <li className="break-content">{commentary}</li>
                  </ul>
                );
              },
            )}
            placement="left"
            overlayInnerStyle={{ maxWidth: "700px" }}
          >
            <span>{CellRenderers.VALUE_OR_NA(scoreValue)}</span>
          </Popover>
        );
      }
      return <span>{CellRenderers.VALUE_OR_NA(scoreValue)}</span>;
    },
    [featureFlags.AATIV2_SCORE],
  );

  const aatiScoreColumn = useMemo(
    () => ({
      title: "AATI Score",
      dataIndex: "aatiScore",
      key: "aatiScore",
      render: getAATIScoreWithPopover,
      width: 150,
      sorter: true,
    }),
    [getAATIScoreWithPopover],
  );

  return {
    getAATIScoreWithPopover,
    aatiScoreColumn,
  };
};
